// External dependencies
import { useTranslation } from 'react-i18next';
import React from 'react';

// Internal dependencies
import { useLanguagesQuery } from '@/modules/core/client/api/languages.api';

import {
  languageLevelLabels,
  type LanguageLevels,
} from '../../shared/language-levels';

export default function LanguageList({
  languages = [],
  className,
  emphasisedLanguages = [],
  languageLevels = {},
}: {
  languages?: string[];
  className?: string;
  emphasisedLanguages?: string[];
  languageLevels?: LanguageLevels;
}) {
  const { t } = useTranslation(['languages', 'users']) as {
    t: (key: string, options?: Record<string, unknown>) => string;
  };
  const { data: languageNames, isLoading } = useLanguagesQuery() as {
    data?: Record<string, string>;
    isLoading: boolean;
  };

  if (isLoading || !languages.length) {
    return null;
  }

  return (
    <ul className={className}>
      {languages.map(code => {
        const name = languageNames?.[code]
          ? // i18next-extract-disable-next-line
            t(languageNames[code], { ns: 'languages' })
          : code;
        return (
          <li key={code}>
            {emphasisedLanguages.includes(code) ? (
              <strong>{name}</strong>
            ) : (
              name
            )}
            {languageLevels[code] && (
              // i18next-extract-disable-next-line
              <>
                {' '}
                —{' '}
                {t(languageLevelLabels[languageLevels[code]], { ns: 'users' })}
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
}
